import React from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';

interface FlameMarkProps extends SvgIconProps {
  cutoutColor?: string;
}

export const FlameMark: React.FC<FlameMarkProps> = ({ cutoutColor = '#F5F5F5', ...props }) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C12 2 6 9 6 14C6 17.31 8.69 20 12 20C15.31 20 18 17.31 18 14C18 9 12 2 12 2Z"
      fill="currentColor"
    />
    <path
      d="M12 8C12 8 9 12 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 12 12 8 12 8Z"
      fill={cutoutColor}
    />
  </SvgIcon>
);
